import _get from 'lodash/get';


const getErrors = state => state.siteFooterLinks.errors;
export const getLoadSiteFooterLinksError = state => (
  _get(getErrors(state), 'loadSiteFooterLinksError')
);
export const getCreateSiteFooterLinkCategoryError = state => (
  _get(getErrors(state), 'createSiteFooterLinkCategoryError')
);
export const getSetSiteFooterLinkCategoryTranslationError = state => (
  _get(getErrors(state), 'setSiteFooterLinkCategoryTranslationError')
);
export const getDeleteSiteFooterLinkCategoryTranslationError = state => (
  _get(getErrors(state), 'deleteSiteFooterLinkCategoryTranslationError')
);
export const getDeleteSiteFooterLinkCategoryError = state => (
  _get(getErrors(state), 'deleteSiteFooterLinkCategoryError')
);
export const getEditSiteFooterLinkCategoryError = state => (
  _get(getErrors(state), 'editSiteFooterLinkCategoryError')
);

// Footer links
export const getCreateSiteFooterLinkError = state => (
  _get(getErrors(state), 'createSiteFooterLinkError')
);
export const getEditSiteFooterLinkError = state => (
  _get(getErrors(state), 'editSiteFooterLinkError')
);
export const getDeleteSiteFooterLinkError = state => (
  _get(getErrors(state), 'deleteSiteFooterLinkError')
);
export const getCreateSiteFooterLinkTranslationError = state => (
  _get(getErrors(state), 'createSiteFooterLinkTranslationError')
);
export const getDeleteSiteFooterLinkTranslationError = state => (
  _get(getErrors(state), 'deleteSiteFooterLinkTranslationError')
);
export const getSetSiteFooterLinkTranslationAvailabilityError = state => (
  _get(getErrors(state), 'setSiteFooterLinkTranslationAvailabilityError')
);
export const getEditSiteFooterLinkTranslationError = state => (
  _get(getErrors(state), 'editSiteFooterLinkTranslationError')
);
